import { useEffect } from "react";
import { Navbar } from "@/components/Navbar";
import { LatestBuildBanner } from "@/components/LatestBuildBanner";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { GarageWall } from "@/components/GarageWall";
import { JourneyVideo } from "@/components/JourneyVideo";
import { RiderProblems } from "@/components/RiderProblems";
import { Timeline } from "@/components/Timeline";
import { FoundersJournal } from "@/components/FoundersJournal";
import { ProductTeaser } from "@/components/ProductTeaser";
import { TechPack } from "@/components/TechPack";
import { GreeceInspiration } from "@/components/GreeceInspiration";
import { FactoryDevelopment } from "@/components/FactoryDevelopment";
import { EmailSignup } from "@/components/EmailSignup";
import { BuiltTogetherTeaser } from "@/components/BuiltTogetherTeaser";
import { FinalCta } from "@/components/FinalCta";
import { Footer } from "@/components/Footer";

export default function Home() {
  useEffect(() => {
    document.title = "ROADRIG · The Journey Behind The Bag";
  }, []);

  return (
    <div data-testid="home-page" className="relative bg-[#0A0A0C] text-white">
      <Navbar />
      <LatestBuildBanner />
      <Hero />
      <About />
      <GarageWall />
      <JourneyVideo />
      <RiderProblems />
      <Timeline />
      <FoundersJournal />
      <ProductTeaser />
      <TechPack />
      <GreeceInspiration />
      <FactoryDevelopment />
      <BuiltTogetherTeaser />
      <EmailSignup source="homepage" />
      <FinalCta />
      <Footer />
    </div>
  );
}
